<template>
  <div id="canvas">
    <div class="download-search">
      <div class="row">
        <div class="col-md-4">
          <nav aria-label="breadcrumb">
            <ol class="report-bread breadcrumb">
              <li class="breadcrumb-item"><a href="#">Report</a></li>
              <li class="breadcrumb-item active" aria-current="page">
                Desking Recap Report
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-md-8">
          <div class="download-links">
            <ul class="d-flex align-items-center justify-content-end">
              <!---start--->
              <li class="timeline">
                <button
                  type="button"
                  v-on:click="getSoldDealRecapReport('today')"
                  v-bind:class="filters_.duration == 'today' ? 'current' : ''"
                >
                  <span class="today">Today</span>
                </button>
              </li>
              <li class="timeline">
                <button
                  type="button"
                  v-bind:class="filters_.duration == 'month' ? 'current' : ''"
                  v-on:click="getSoldDealRecapReport('month')"
                >
                  <span class="today">This Month</span>
                </button>
              </li>
              <li class="timeline datepicker-timeline">
                <button
                  type="button"
                  class="calender"
                  v-bind:class="filters_.duration == 'custom' ? 'current' : ''"
                >
                  <date-range-picker
                    :opens="'left'"
                    :ranges="false"
                    :locale-data="{ format: 'yyyy-mm-dd' }"
                    v-model="filters_.customDate"
                    @update="getSoldDealRecapReport('custom')"
                  ></date-range-picker
                  ><span class="calender">Custom Date</span>
                </button>
              </li>
              <li class="timeline">
                 <button
                  @click="exportSalesRapData(filters_.duration)"
                  :disabled="btnLoader"
                  type="button"
                >
                  <span v-if="btnLoader"
                    ><span class="spinner-grow spinner-grow-sm"></span>
                    Loading...</span
                  >
                  <span v-if="!btnLoader"> Export CSV</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ounter-grid -->
    <div class="">
      <div class="dataTables_wrapper no-footer">
        <div class="graph-area">
          <div class="grap-title">
            <div class="title-grap">
              <h4>Desking Deal Recap Report</h4>
            </div>
          </div>
          <table
            id="soldDealRecap"
            class="customReportsTable display"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr>
                <th class="text-center">Name</th>
                <th class="text-center">Address</th>
                <th class="text-center">City</th>
                <th class="text-center">State</th>
                <th class="text-center">Zip Code</th>
                <th class="text-center">Birthday</th>
                <th class="text-center">Email Address</th>
                <th class="text-center">Home Phone</th>
                <th class="text-center">Cell Phone</th>
                <th class="text-center">Work Phone</th>
                <th class="text-center">Stock#</th>
                <th class="text-center">VIN</th>
                <th class="text-center">Vehicle</th>
                <th class="text-center">Date Active</th>
                <th class="text-center">Date Sold</th>
                <th class="text-center">Front</th>
                <th class="text-center">Back</th>
                <th class="text-center">Total</th>
                <th class="text-center">Sale Price</th>
                <th class="text-center">P/L</th>
                <th class="text-center">N/U</th>
                <th class="text-center">Salesperson</th>
                <th class="text-center">FI Manager</th>
                <th class="text-center">Up Type</th>
                <th class="text-center">Source</th>
                <th class="text-center">Deal Status</th>
                <th class="text-center">DMS Deal ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in soldDealRecap" :key="data.key">
                <td class="text-center">{{ data.name }}</td>
                <td class="text-center">{{ data.address }}</td>
                <td class="text-center">{{ data.city }}</td>
                <td class="text-center">{{ data.state }}</td>
                <td class="text-center">{{ data.zip }}</td>
                <td class="text-center">{{ data.dob }}</td>
                <td class="text-center">{{ data.email }}</td>
                <td class="text-center">{{ data.home_phone }}</td>
                <td class="text-center">{{ data.cell_phone }}</td>
                <td class="text-center">{{ data.work_phone }}</td>
                <td class="text-center">{{ data.stock_number }}</td>
                <td class="text-center">{{ data.vin }}</td>
                <td class="text-center">{{ data.vehicle }}</td>
                <td class="text-center">{{ data.date_active }}</td>
                <td class="text-center">{{ data.date_sold }}</td>
                <td class="text-center">{{ data.front }}</td>
                <td class="text-center">{{ data.back }}</td>
                <td class="text-center">{{ data.total }}</td>
                <td class="text-center">{{ data.sale_price }}</td>
                <td class="text-center">{{ data.purchased_or_leased }}</td>
                <td class="text-center">{{ data.new_or_used }}</td>
                <td class="text-center">{{ data.sale_persons }}</td>
                <td class="text-center">{{ data.manager }}</td>
                <td class="text-center">{{ data.up_type }}</td>
                <td class="text-center">{{ data.source }}</td>
                <td class="text-center">{{ data.status }}</td>
                <td class="text-center">{{ data.deal_id }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- graph-area -->
</template>
<script>
import axios from "axios";
// import VueApexCharts from "vue-apexcharts";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import axios from "axios";

// import jsPDF from "jspdf";
// import * as htmlToImage from "html-to-image";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-responsive";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import moment from "moment";
// // import moment from "moment";
// // import jsPDF from "jspdf";
// // import html2canvas from "html2canvas";
export default {
  name: "AppointmentByRap",
  components: { DateRangePicker },
  data() {
    return {
      btnLoader:false,
      soldDealRecap: null,
      soldDealRecapObject: null,
      filters_: {
        duration: "month",
        customDate: {},
        id: 0,
        tm_id: 0,
        from: "",
        to: "",
        export: false,
      },
    };
  },
  mounted() {
    this.getSoldDealRecapReport();
  },
  beforeUpdate() {
    if (this.soldDealRecapObject) {
      this.soldDealRecapObject.fnDestroy();
    }
  },
  methods: {
    exportSalesRapData(duration) {
      console.log(duration);
      this.filters_.export = true;
      this.btnLoader = true;
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "solddealrecap", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.filters_.export = false;
          this.btnLoader = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "solddealrecap.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },
    getSoldDealRecapReport(duration = "month") {
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "solddealrecap", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((response) => {
          if ($.fn.DataTable.isDataTable("#soldDealRecap")) {
            $("#soldDealRecap").DataTable().destroy();
          }
          this.soldDealRecap = response.data;
          setTimeout(() => {
            if ($.fn.DataTable.isDataTable("#soldDealRecap")) {
              $("#soldDealRecap").DataTable().draw();
            } else {
              $("#soldDealRecap").DataTable({
                responsive: true,
                paging: false,
                bFilter: false,
                ordering: false,
                bInfo: false,
              });
            }
          });
        });
    },
  },
};
</script>
<style scoped>
.timeline {
  margin: 0px !important;
}
.datepicker-timeline {
  overflow: visible;
  margin-right: 5px !important;
}
.calender {
  position: relative;
}
.calender .vue-daterange-picker {
  position: absolute;
}
.calender .daterangepicker.opensleft {
  right: -100px;
}
.td {
  position: relative;
  right: -7px;
}
</style>
